module.exports = __webpack_public_path__ + "img/KE.cc0e217a.svg";